import React from "react"

import globalStyles from "../../../../App.module.scss";
import command from './images/command.png'
import qrOutput from './images/qrcode.png'
import {Prism as SyntaxHighlighter} from "react-syntax-highlighter";
import {dracula} from "react-syntax-highlighter/dist/cjs/styles/prism";

export default function QrCodeGenerator() {

    let data = `import argparse

import qrcode


def generate_qr(data, output_path):
    img = qrcode.make(data)
    img.save(output_path)


def main():
    parser = argparse.ArgumentParser(description="Generate a QR code from text or a URL")
    parser.add_argument("data", help="text, URL, or Wi-Fi string to encode")
    parser.add_argument("-o", "--output", default="qrcode.png")
    args = parser.parse_args()

    generate_qr(args.data, args.output)
    print(f"Saved QR code to {args.output}")


if __name__ == "__main__":
    main()
`

    return (
        <div className={globalStyles.article}>
            <h1>QR code generator</h1>
            <p>Encodes any text — a URL, a Wi-Fi password string, a business card's worth of contact info — into a
                scannable QR code PNG. Requires the <code>qrcode</code> package:
                {' '}<code>pip install qrcode</code></p>
            <div style={{maxWidth: '800px'}}>
                <SyntaxHighlighter
                    children={data}
                    style={dracula}
                    PreTag="div"
                    language={'python'}
                />
            </div>

            <p>Running it against a URL:</p>
            <div style={{maxWidth: '800px'}}>
                <img src={command} alt={""}/>
            </div>

            <p>The generated, scannable QR code:</p>
            <div style={{maxWidth: '220px'}}>
                <img src={qrOutput} alt={""}/>
            </div>
        </div>
    )
}
